import { render, staticRenderFns } from "./AddressHeader.vue?vue&type=template&id=12466f8c&"
import script from "./AddressHeader.vue?vue&type=script&lang=js&"
export * from "./AddressHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/fhartwig/Sites/DIA-3dprima_v2/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('12466f8c')) {
      api.createRecord('12466f8c', component.options)
    } else {
      api.reload('12466f8c', component.options)
    }
    module.hot.accept("./AddressHeader.vue?vue&type=template&id=12466f8c&", function () {
      api.rerender('12466f8c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/src/app/components/customer/addressSelectCheckoutCustom/AddressHeader.vue"
export default component.exports